angular.module('ihestiaWidgets.policyDetails')
  .controller('editChildModalCtrl', ['$scope', 'editChildModalHelper', 
    function ($scope, editChildModalHelper) {
      editChildModalHelper.initData();
      $scope.tplData = editChildModalHelper.tplData;
    }]);
